import { FunctionComponent } from 'react'

import { Avatar, Grid } from '@material-ui/core'

import { MdErrorOutline, MdKeyboardArrowRight } from 'react-icons/md'
import {
  IconMessage,
  TextFrotista,
  CardFrotista,
  ArrowButton,
  TextCnpj,
  ErrorMessage,
  Message,
} from './styles'
import { colors } from 'shared/styles/colors'
import { HorizontalLine } from '../../styles'
import { useHistory } from 'react-router-dom'
import EStatusConta from 'modules/lotes/domain/entities/EStatusConta'

interface TProps {
  razaoSocial: string
  cnpj: string
  mensagemStatusConta: string
  statusConta: string
}

const CardFrotistaSemContaPay: FunctionComponent<TProps> = ({
  razaoSocial,
  cnpj,
  mensagemStatusConta,
  statusConta,
}) => {
  const history = useHistory()

  const handleClickFrotista = () => {
    switch (statusConta) {
      case EStatusConta.ATIVA:
        break
      case null:
        history.push('/tmov-pay-instructions')
        break
      case EStatusConta.EM_ANALISE:
        break
      default:
        break
    }
  }

  const tratarRazaoSocial = (): string => {
    return razaoSocial.length >= 32
      ? razaoSocial.substring(0, 30) + '...'
      : razaoSocial
  }

  return (
    <CardFrotista>
      <Grid container>
        <Grid item sm={1} md={1} lg={1}>
          <Avatar style={{ backgroundColor: colors.blue }}>
            {razaoSocial.charAt(0)}
          </Avatar>
        </Grid>

        <Grid item sm={10} md={10} lg={10}>
          <TextFrotista>{tratarRazaoSocial()}</TextFrotista>
          <TextCnpj>{cnpj}</TextCnpj>
        </Grid>

        <Grid item sm={1} md={1} lg={1}>
          {statusConta !== EStatusConta.EM_ANALISE &&
            statusConta !== EStatusConta.RECUSADA && (
              <ArrowButton onClick={handleClickFrotista}>
                <MdKeyboardArrowRight color={colors.gray} size={30} />
              </ArrowButton>
            )}
        </Grid>
        <HorizontalLine></HorizontalLine>
      </Grid>

      <Grid container>
        <Grid item sm={1} md={1}>
          <IconMessage>
            {statusConta !== EStatusConta.EM_ANALISE ? (
              <MdErrorOutline color={colors.red2} />
            ) : (
              <MdErrorOutline color={colors.yellow} />
            )}
          </IconMessage>
        </Grid>

        <Grid item sm={10} md={10}>
          {statusConta !== EStatusConta.EM_ANALISE ? (
            <ErrorMessage>{mensagemStatusConta}</ErrorMessage>
          ) : (
            <Message>{mensagemStatusConta}</Message>
          )}
        </Grid>
      </Grid>
    </CardFrotista>
  )
}

export default CardFrotistaSemContaPay
